module.exports = __webpack_public_path__ + "img/yjya.c3190765.png";